import { MenuItem, Select } from '@mui/material';
import { ConditionOperatorEnum, type Condition } from '@repo/api-gw-sdk';

import { PropertyPolicyRelation } from '@/types/advanceFilter';

import { inlineDropdownStyle } from './inlineDropdownStyle';

export const OPERATORS: Record<
  PropertyPolicyRelation,
  Partial<Record<ConditionOperatorEnum, { label: string }>>
> = {
  [PropertyPolicyRelation.SingleValue]: {
    [ConditionOperatorEnum.In]: { label: 'is one of' },
    [ConditionOperatorEnum.NotIn]: { label: 'is not one of' },
  },
  [PropertyPolicyRelation.MultipleValues]: {
    [ConditionOperatorEnum.ContainsAnyOf]: { label: 'contains any of' },
    [ConditionOperatorEnum.Contains]: { label: 'contains all of' },
    [ConditionOperatorEnum.ContainsNoneOf]: { label: 'contains none of' },
  },
  [PropertyPolicyRelation.String]: {
    [ConditionOperatorEnum.In]: { label: 'is one of' },
    [ConditionOperatorEnum.NotIn]: { label: 'is not one of' },
    [ConditionOperatorEnum.Contains]: { label: 'contains' },
    [ConditionOperatorEnum.NotContains]: { label: 'does not contain' },
    [ConditionOperatorEnum.StartsWith]: { label: 'starts with' },
    [ConditionOperatorEnum.NotStartsWith]: {
      label: 'does not start with',
    },
    [ConditionOperatorEnum.EndsWith]: { label: 'ends with' },
    [ConditionOperatorEnum.NotEndsWith]: { label: 'does not end with' },
  },
  [PropertyPolicyRelation.Boolean]: {
    [ConditionOperatorEnum.In]: { label: 'detected' },
    [ConditionOperatorEnum.NotIn]: { label: 'not detected' },
  },
};

interface OperatorSelectProps {
  condition: Condition;
  propertyRelation: PropertyPolicyRelation;
  onChange: (condition: Condition) => void;
}

export function OperatorSelect({
  condition,
  propertyRelation,
  onChange,
}: OperatorSelectProps) {
  return (
    <Select
      sx={{ ...inlineDropdownStyle, height: '100%' }}
      MenuProps={{ disablePortal: true }}
      value={condition.operator ?? ''}
      onChange={(event) =>
        onChange({
          ...condition,
          operator: event.target.value,
          value: [],
        })
      }
    >
      {Object.entries(OPERATORS[propertyRelation]).map(([key, value]) => (
        <MenuItem key={key} value={key}>
          {value.label}
        </MenuItem>
      ))}
    </Select>
  );
}
